import { render, staticRenderFns } from "./VehicleSelect.vue?vue&type=template&id=4efccac4&"
import script from "./VehicleSelect.vue?vue&type=script&lang=ts&"
export * from "./VehicleSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports